import React, { useEffect } from "react";
import Page1 from "./pages/Page1";
import Page2 from "./pages/Page2";
import Page3 from "./pages/Page3";
import Page4 from "./pages/Page4";
import { db } from "./firebase";
import { collection, addDoc } from "firebase/firestore";
import ReactGA from "react-ga4";

// Initialize Google Analytics
ReactGA.initialize("G-7LJ1EL52S3");

function App() {
  useEffect(() => {
    // Track page view
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });

    // Firebase Firestore test connection
    const testConnection = async () => {
      try {
        const docRef = await addDoc(collection(db, "testCollection"), {
          message: "Firebase connection successful!",
          timestamp: new Date(),
        });
        console.log("✅ Test document written with ID:", docRef.id);
      } catch (e) {
        console.error("❌ Firebase test failed:", e);
      }
    };

    testConnection();
  }, []);

  return (
    <div className="App">
      <Page1 />
      <Page2 />
      <Page3 />
      <Page4 />
    </div>
  );
}

export default App;
